<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoObras" :items-per-page="20">
      <template v-slot:[`item.clave`]=" { item }">
        <router-link
        :to="{name: 'obra', params: { idObra: item.id }}">
          {{ item.clave }}
        </router-link>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        <v-chip :color="item.tipo.color">
          <span>
            {{item.tipo.descripcion}}
          </span>
        </v-chip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :obra="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.meta`]="{ item }">
        <cortar-texto
        :texto="item.meta"></cortar-texto>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ListadoPlaneacionDesktop',
  props: {
    listadoObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
    CortarTexto,
  },
  data() {
    return {
      headers: [
        {
          text: 'Clave',
          align: 'start',
          value: 'clave',
          width: '115',
          sortable: false,
        },
        { text: 'Tipo', value: 'tipo', sortable: false },
        {
          text: 'Objeto', width: '50%', value: 'meta', sortable: false,
        },
        { text: 'Municipio', value: 'ubicacion.municipio.nombre', sortable: false },
        { text: 'Programa', value: 'programa.nombre', sortable: false },
        { text: 'F. Registro', value: 'createdAt', width: '120' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
